const HeltHjem = () => (
    <svg
        width="16"
        role="img"
        aria-label="Helt Hjem logo"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.84086 7.15886L3.34552 4.96994C3.18477 4.9059 3.00098 5.02182 3.00098 5.20369V9.14669C3.00098 9.2498 3.06374 9.34266 3.1598 9.38044L8.65514 11.5565C8.81844 11.6212 8.99904 11.5015 8.99904 11.3228V7.39197C8.99904 7.28951 8.93628 7.19665 8.84086 7.15886Z"
            fill="#FFBE00"
        />
        <path
            d="M8.84069 12.0305L5.68731 10.7766C5.51312 10.71 5.34277 10.84 5.34277 11.0103V13.4381C5.34277 13.5425 5.40681 13.6353 5.50416 13.6731L8.65753 14.8829C8.82083 14.9456 8.99887 14.8259 8.99887 14.6478V12.2642C8.99887 12.1611 8.93611 12.0683 8.84069 12.0305Z"
            fill="#FFBE00"
        />
        <path
            d="M4.78225 10.4229L3.34454 9.85041C3.17611 9.78317 3 9.90933 3 10.0842V12.5119C3 12.6151 3.06276 12.7073 3.15818 12.7457L4.5959 13.3182C4.75664 13.3816 4.94043 13.2663 4.94043 13.0845V10.6567C4.94107 10.5536 4.87831 10.4614 4.78225 10.4229Z"
            fill="#FFBE00"
        />
        <path
            d="M13.3035 5.18054L9.53344 7.20231C9.45147 7.24586 9.40088 7.33103 9.40088 7.42389V14.6656C9.40088 14.8597 9.60837 14.9743 9.77103 14.8872L13.5411 12.8654C13.6231 12.8219 13.6737 12.7367 13.6737 12.6439V5.40212C13.6737 5.21192 13.47 5.09088 13.3035 5.18054Z"
            fill="#4D4D4D"
        />
        <path
            d="M11.8043 2.95592L6.38391 1.01804C6.27952 0.976415 6.16041 1.00843 6.09188 1.09745L3.41114 4.24634C3.317 4.35649 3.34517 4.56526 3.51616 4.63379L9.0115 6.84447C9.12678 6.89058 9.24589 6.84127 9.30545 6.76378L11.9164 3.344C12.0253 3.20183 11.951 3.00843 11.8043 2.95592Z"
            fill="#4D4D4D"
        />
    </svg>
);
export default HeltHjem;
